import React, { useContext, useEffect, useState } from 'react'
import { NewContext } from '../../Context/NewContext';
import { get_bank_data } from '../../Controller/actions';
import { SearchAndAddBtn } from '../../Components';
import { toast } from 'react-toastify';


const ApiResponse = () => {
    const { tokenType, permissions, formData, handleChange, setFormData, deleteUpdateTag, deleteUpdateYes, search, currentPage, perPage, filterDropdown, sortData, isAscending } = useContext(NewContext);
    const [bankdata, setbankdata] = useState({});

    const handleClick = async (e) => {
        e.preventDefault();
        if (!formData.countryCode) {
            // alert('Please enter a country code.');
            toast.error("please fill out this field");
            return;
        }
        let createUpdateBank;
        createUpdateBank = await get_bank_data(formData)
        if (createUpdateBank) {
            setbankdata(createUpdateBank);
            const { message, status, data } = createUpdateBank;
            if (status) {
                toast.success(message);
                // setFormData({
                //     countryCode: "",
                //     bankName: "",
                //     bankRegex: ""
                // });
            } else {

            };
        }
    }
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'API_response')
            setPagePermissions({
                ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D
            })
        }
    }, [tokenType, permissions])


    useEffect(() => {
        setFormData({ countryCode: '' })
    }, [])
    return (
        <div>
            <SearchAndAddBtn title={`API Response`} addBtn={false} isSearch={false} countryFilter={false} perPageCount={false} />
            <div class="mb-5">
                <label
                    htmlFor="countryCode"
                    class="mb-3 block text-base font-medium text-[#07074D]"
                >
                    Country
                </label>
                <input
                    type="text"
                    name="countryCode"
                    onChange={handleChange}
                    value={formData?.countryCode || ''}
                    placeholder="Bank Country"
                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#0047ff] focus:shadow-md"
                    required
                />
            </div>
            <div>
                <button onClick={handleClick}
                    class="hover:shadow-form rounded-md bg-[#0047ff] py-3 px-8 text-base font-semibold text-white outline-none">
                    Submit
                </button>
            </div>
            {bankdata && (
                <div className="mt-5 p-5 border border-[#e0e0e0] bg-white rounded-md">
                    <h3 className="text-lg font-medium text-[#07074D]">API Response:</h3>
                    {/* <div className="mt-3 p-3 bg-gray-100 rounded">
                        <pre className='grid grid-cols-12'>
                            {JSON.stringify(bankdata, null, 2)}
                        </pre>
                    </div> */}
                    <div className="mt-3 p-3 bg-gray-100 rounded overflow-auto">
                        <pre className='whitespace-pre-wrap break-words'>
                            {JSON.stringify(bankdata, null, 2)}
                        </pre>
                    </div>

                </div>
            )}
        </div>
    )
}

export default ApiResponse
